import { render } from "./FinalSettlementInformation.vue?vue&type=template&id=edbf80d8"
import script from "./FinalSettlementInformation.vue?vue&type=script&lang=js"
export * from "./FinalSettlementInformation.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__